<template>
  <div class="marketDemand">
    <div class="table">
      <a-row
        :gutter="16"
        v-for="(item, index) in tableList"
        :key="'item' + index"
        :class="[index === tableList.length - 1 ? 'last' : '']"
      >
        <a-col class="gutter-row" :span="9">
          <div class="gutter-box name" @click="detailClick(item)">
            {{ item.name }}
          </div>
        </a-col>
        <a-col class="gutter-row" :span="4">
          <div class="gutter-box">
            需求类型: <span class="type">{{ item.demandsTypeStr }}</span>
          </div>
        </a-col>
        <a-col class="gutter-row" :span="7">
          <div class="gutter-box">
            产业分类:
            <span
              class="classify"
              v-if="item.industrialTypeStr && item.industrialTypeStr !== null"
              >{{ item.industrialTypeStr }}</span
            >
          </div>
        </a-col>
        <a-col class="gutter-row" :span="4">
          <div class="gutter-box right">
            发布时间:
            <div>{{ item.publishTime }}</div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { isView } from '@/api/technicalR'
export default {
  props: {
    tableList: Array
  },
  data() {
    return {}
  },

  mounted() {},
  methods: {
    async detailClick(item) {
      this.$router.push({ name: 'techDetailDeal', query: { id: item.id } })
      await isView(item.id)
    }
  }
}
</script>
